import ApiService from "../../api/api.service";
import { GET_REAL_ESTATE_FORM_DETAIL, DELETE_REAL_ESTATE_FORM, SAVE_REAL_ESTATE_FORM_DETAIL, GET_REAL_ESTATE_FORM,
GET_CITY, GET_LOCATION_LIST, GET_EDIT_REAL_ESTATE_FORM, UPDATE_REAL_ESTATE_FORM, GET_COMMERCIAL_FORM, GET_INDUSTRIAL_FORM,
GET_LAND_FORM, GET_REIT_FORM, GET_IIT_FORM, GET_INVESTMENT_TRUST_TYPE, GET_INVESTMENT_TRUST_PRICE, GET_LOCATION_PRICE } from "../actions.type";

const getDefaultRealEstateState = () => {
	return {
		realEstateFormDetail: {},
		saveRealEstateFormDetail: {},
		realEstateForm: {},
		realEstateType: {},
		city: {},
		locationList: {},
		editRealEstateForm: {},
		updateRealEstateForm: {},
		commercialForm: {},
		industrialForm: {},
		landForm: {},
		reitForm: {},
		iitForm: {},
		investmentTrustType: {},
		investmentTrustPrice: {},
		locationPrice: {},
	}
};

const state = getDefaultRealEstateState();

const getters = {

	getRealEstateFormDetail(state) {
		return state.realEstateFormDetail;
	},
	getSaveRealEstateFormDetail(state) {
		return state.saveRealEstateFormDetail;
	},
	getRealEstateForm(state) {
		return state.realEstateForm;
	},
	getRealEstateType(state) {
		return state.realEstateType;
	},
	getCity(state) {
		return state.city;
	},
	getLocationList(state) {
		return state.locationList;
	},
	getEditRealEstateForm(state) {
		return state.editRealEstateForm;
	},
	getUpdateRealEstateForm(state) {
		return state.updateRealEstateForm;
	},
	getCommercialForm(state) {
		return state.commercialForm;
	},
	getIndustrialForm(state) {
		return state.industrialForm;
	},
	getLandForm(state) {
		return state.landForm;
	},
	getReitForm(state) {
		return state.reitForm;
	},
	getIitForm(state) {
		return state.iitForm;
	},
	getInvestmentTrustType(state) {
		return state.investmentTrustType;
	},
	getInvestmentTrustPrice(state) {
		return state.investmentTrustPrice;
	},
	getLocationPrice(state) {
		return state.locationPrice;
	},
};

const mutations = {

	setRealEstateFormDetail (state, data) {
		state.realEstateFormDetail = data
	},
	setSaveRealEstateFormDetail (state, data) {
		state.saveRealEstateFormDetail = data
	},
	setRealEstateForm (state, data) {
		state.realEstateForm = data
	},
	setRealEstateType (state, data) {
		state.realEstateType = data
	},
	setCity (state, data) {
		state.city = data
	},
	setLocationList (state, data) {
		state.locationList = data
	},
	setEditRealEstateForm (state, data) {
		state.editRealEstateForm = data
	},
	setUpdateRealEstateForm (state, data) {
		state.updateRealEstateForm = data
	},
	setCommercialForm (state, data) {
		state.commercialForm = data
	},
	setIndustrialForm (state, data) {
		state.industrialForm = data
	},
	setLandForm (state, data) {
		state.landForm = data
	},
	setReitForm (state, data) {
		state.reitForm = data
	},
	setIitForm (state, data) {
		state.iitForm = data
	},
	setInvestmentTrustType (state, data) {
		state.investmentTrustType = data
	},
	setInvestmentTrustPrice (state, data) {
		state.investmentTrustPrice = data
	},
	setLocationPrice (state, data) {
		state.locationPrice = data
	},
};


const actions = {

	[GET_REAL_ESTATE_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setRealEstateFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_REAL_ESTATE_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveRealEstateFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_REAL_ESTATE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setRealEstateForm',data);
				data.data.master_data.forEach(element => {

					if (element.getRealStateType) {
						context.commit('setRealEstateType',element.getRealStateType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_CITY](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCity',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_LOCATION_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLocationList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EDIT_REAL_ESTATE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditRealEstateForm',data);
				data.data.master_data.forEach(element => {

					if (element.getRealStateType) {
						context.commit('setRealEstateType',element.getRealStateType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_REAL_ESTATE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateRealEstateForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_COMMERCIAL_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCommercialForm',data);
				data.data.master_data.forEach(element => {

					if (element.getRealStateType) {
						context.commit('setRealEstateType',element.getRealStateType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_INDUSTRIAL_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setIndustrialForm',data);
				data.data.master_data.forEach(element => {

					if (element.getRealStateType) {
						context.commit('setRealEstateType',element.getRealStateType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_LAND_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLandForm',data);
				data.data.master_data.forEach(element => {

					if (element.getRealStateType) {
						context.commit('setRealEstateType',element.getRealStateType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_REIT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setReitForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_IIT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setIitForm',data);
				data.data.master_data.forEach(element => {

					if (element.getRealStateType) {
						context.commit('setRealEstateType',element.getRealStateType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_INVESTMENT_TRUST_TYPE](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setInvestmentTrustType',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_INVESTMENT_TRUST_PRICE](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setInvestmentTrustPrice',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_LOCATION_PRICE](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLocationPrice',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
};

export default {
	getters,
	actions,
	mutations,
	state
}